import { Box, Tab } from "@mui/material";
import { ApplicantWrapperStyled } from "Components/Applicants/ApplicantProfile/Applicant.styled";
import { ApplicantPath, ApplicantPathEnum } from "Components/Applicants/ApplicantProfile/ApplicantProfileModel";
import { useEffect, useState } from "react";
import { Link, Outlet, useLocation, useParams } from "react-router-dom";
import { ShTabs } from "shared/SharedStyles/ShNavigation";

export const ApplicantWrapper = () => {
    const pathname = useLocation()?.pathname?.split('/').pop();
    const { jobId, applicantId } = useParams();
    const [curPage, setCurPage] = useState<ApplicantPath>(pathname as ApplicantPath);

    // Set tab selection based on url path.
    useEffect(() => {
        if (pathname) {
            setCurPage(pathname as ApplicantPath);
        }
    }, [pathname]);

    return (<>
        <ApplicantWrapperStyled>
            <Box paddingX={{ xs: 2, sm: 3, md: 4, lg: 4 }}>
                <ShTabs className="applicant-tabs" aria-label="Applicant Tabs" variant="scrollable" scrollButtons='auto' allowScrollButtonsMobile
                    value={curPage} onChange={(e, nV) => setCurPage(nV as ApplicantPath)}>
                    <Tab label="Profile" component={Link} value={ApplicantPathEnum.Profile} to={`/employer/job/${jobId}/applicant/${applicantId}/profile`} />
                    <Tab label="Resume" component={Link} value={ApplicantPathEnum.Resume} to={`/employer/job/${jobId}/applicant/${applicantId}/resume`} />
                    <Tab label="Comments" component={Link} value={ApplicantPathEnum.Comments} to={`/employer/job/${jobId}/applicant/${applicantId}/comments`} />
                    <Tab label="Questions" component={Link} value={ApplicantPathEnum.Questions} to={`/employer/job/${jobId}/applicant/${applicantId}/questions`} />
                    {/* <Tab label="Stage" component={Link} value={ApplicantPathEnum.Stage} to={`/employer/job/${jobId}/applicant/${applicantId}/stage`} /> */}
                </ShTabs>
            </Box>
            <Box className="applicant-outlet" padding={{ xs: 2, sm: 3, md: 4, lg: 4 }} flex={1}>
                <Outlet />
            </Box>
        </ApplicantWrapperStyled>
    </>);
};